'use strict';

/**
 * Takes any number of objects with all string values and returns an object with the strings "merged". For every common
 * key among the passed in objects, the returned object will concatenate the values with a space in between.
 * @param  {object} ...classNameConfigs Objects to merge.
 * @return {object}
 */
function mergeClassNames(...classNameConfigs) {
    return classNameConfigs.reduce((acc, classNameConfig) => {
        if (!classNameConfig) {
            return acc;
        }

        Object.keys(classNameConfig).forEach(className => {
            const value = classNameConfig[className];

            if (!acc[className]) {
                acc[className] = value;
            } else {
                acc[className] += ' ' + value;
            }
        });

        return acc;
    }, {});
}

module.exports = mergeClassNames;



// WEBPACK FOOTER //
// ./assets/js/global/utils/mergeClassNames.es.js